import { Controller } from "stimulus"

// Selecteur d'annee scolaire : chaque <option> porte l'URL de bascule.
export default class extends Controller {
  change(event) {
    const url = event.target.value
    if (url) window.location.assign(url)
  }
}
